import type { PaymentStatus } from "@/api-v3";

export function getStatusColor(status: PaymentStatus) {
  switch (status) {
    case "approved":
    case "accepted":
      return "bg-green-500/15 text-green-700 hover:bg-green-500/15";
    case "rejected":
    case "cancelled":
      return "bg-red-500/15 text-red-700 hover:bg-red-500/15";
    case "pending":
      return "bg-blue-500/15 text-blue-700 hover:bg-blue-500/15";
    default:
      throw new Error(`Status "${status as string}" not handled`);
  }
}
